import {api} from './api';


export const orderRequestsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		createOrderRequest: builder.mutation<void, {planId: number, message: string, email: string, vendorId: number}>({
			query: ({planId, message, email, vendorId}) => ({
				url: 'orderRequests',
				method: 'POST',
				body: {planId, message, email, vendorId},
			}),
		}),
	}),
});

export const {useCreateOrderRequestMutation} = orderRequestsApi;
